import type { QueryClient } from "@tanstack/react-query";
import { StudentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchStudentGet(
  studentId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching student");
  }

  const service = createAuthenticatedApi(StudentsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Students, studentId],
    queryFn: () => service.getStudentById({ id: studentId }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
